import { connect } from 'react-redux';

import { IState } from '../../store/index';
import { ExportButton, IExportButtonProps } from './index';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ExportButtonContainer = connect<IExportButtonProps, any, any>((state: IState) => ({
  docxUrl: state.offerData.offer.exportLinks.docxUrl,
  pdfUrl: state.offerData.offer.exportLinks.pdfUrl,
}))(ExportButton);
